<template>
  <div>
    <a-modal title="添加备注" :width="600" :visible="visible" @cancel="hide">

      <a-form :form="form">

        <a-form-item label="机器人id" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-model="rowData.id" disabled/>
        </a-form-item>

        <a-form-item label="备注信息" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['remark', { initialValue:rowData.sub_remark ,rules: [{ required: true, message: '必填项' }] }]" placeholder="请填写" />
        </a-form-item>

      </a-form>

      <template slot="footer">
        <a-button @click="hide">取消</a-button>
        <a-button type="primary" @click="handleSubmit">确定</a-button>
      </template>

    </a-modal>
  </div>
</template>

<script>
import DeviceGroupApi from '@/api/device-group'
export default {
  data() {
    return {
      labelCol: {
        xs: { span: 24 }, sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 }, sm: { span: 13 }
      },
      visible: false,
      form: this.$form.createForm(this),
      rowData: {}
    }
  },

  methods: {
    show(record) {
      this.rowData = record
      this.visible = true
    },

    hide() {
      this.visible = false
      this.form.resetFields()
    },

    handleSubmit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          let data = {
            sub_id: this.rowData.id,
            sub_remark: values.remark
          }
          DeviceGroupApi.setNickName(data)
            .then(res => {
              this.$message.success('设置成功')
              this.hide()
              this.$emit('refresh')
            })
        }
      })
    }
  },

}
</script>

<style scoped></style>